import * as React from 'react';
import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';

import MyAccount from'./MyAccount';
import SignOut from'./SignOut';

import Raosaheb from "../assets/Raosaheb.jpg";
import { logout } from "../slices/auth";
import EventBus from "../common/EventBus";
import { Navigate, useNavigate } from "react-router-dom";
import AuthService from "../services/auth.service";





export default function AccountMenu() {
  let navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const { user } = useSelector((state) => state.auth);
   const { message } = useSelector((state) => state.message);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dispatch = useDispatch();
  const logOut = useCallback(() => {
    
    dispatch(logout());
    console.log("Logout button was pressed")
    
  }, [dispatch]);

  useEffect(() => {
    

    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, [logOut]);

  const [myAccountFormOpen, setMyAccountFormOpen] = useState(false);
  const [settingsFormOpen, setSettingsFormOpen] = useState(false);
  const [signoutDialogOpen, setSignoutDialogOpen] = useState(false);


  const handleMyAccountOpen = () => {
    setMyAccountFormOpen(true);
   };
   const handleMyAccountClose = () => {
    setMyAccountFormOpen(false); 
   };
  
  const handleSignOutOpen = () => {
    setSignoutDialogOpen(true);
   };
   const handleSignOutClose = () => {
    setSignoutDialogOpen(false); 
   };

   const handleLogOut = () =>{
    
    logOut();
    navigate("/login");
    
   };

   
   const [image, setImage] = useState(null);
   const handleImageDownload= async (email) => {
    try {

      const response = await AuthService.downloadProfilePhoto(email);

      //console.log(response.data);
      const base64 = btoa(new Uint8Array(response.data)
        .reduce((data, byte) => data + String.fromCharCode(byte),
         ''));
      setImage('data:image/jpeg; base64,' + base64);
     
      //setImage(response.data);
    } catch (error) {
      console.log(error);
      
    }
  };
  useEffect(() => {handleImageDownload(user.email);}, [myAccountFormOpen]);


  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 0,
              width: '100%', 
              height: '100%', 
            }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar alt="Profile Photo" src={image} />
            {/*<Avatar sx={{ width: 32, height: 32 }}>M</Avatar> */}
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {(user.role !== 'visitor') && (
        <MenuItem onClick={handleMyAccountOpen}>
          <Avatar /> My account
        </MenuItem>
        )}
        <Divider />
        {/*
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem>
        */}
        
        <MenuItem onClick={handleSignOutOpen}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>

      <SignOut
      open = {signoutDialogOpen} 
      close = {handleSignOutClose}
      logout = {handleLogOut}
      />

      <MyAccount
        open = {myAccountFormOpen} 
        close = {handleMyAccountClose}
      />
      
    </React.Fragment>
  );
}